module.exports = require('./helpers/bundle-url').getBundleURL('kBjr5') + "TronLogo.a023c6a9.svg";